export default [
  { label: 'Razão social', field: 'razaoSocial' },
  { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
  // { label: 'Nº Certificado', field: 'numeroCertificado' },
  { label: 'Data emissão', field: 'dataEmissao' },
  // { label: 'Data validade', field: 'dataValidade' },
  {
    label: 'Situação cadastral',
    field: 'situacaoCadastral',
    tdClass: 'col-tamanho-situacao text-center',
    type: 'custom',
  },
  { label: 'Consultado em', field: 'consultadoEm' },
]
